import { render, staticRenderFns } from "./ListSkillCategoryPage.vue?vue&type=template&id=90e719b8&"
import script from "./ListSkillCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ListSkillCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports